var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriggered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08336 2.33268H8.08752H8.08336ZM8.08336 2.33268L6.00002 7.33268L10.1667 9.74768L3.91669 15.666L6.00002 10.666L1.83336 8.24935L8.08336 2.33268ZM8.08336 0.666016C7.65596 0.667945 7.24523 0.832057 6.93419 1.12518L0.686689 7.03768C0.498364 7.21609 0.354329 7.43603 0.266073 7.67996C0.177816 7.9239 0.147778 8.18508 0.178355 8.44268C0.238355 8.96435 0.542522 9.42768 0.996688 9.69102L3.89836 11.3752L2.37669 15.026C2.27165 15.2794 2.23068 15.5548 2.2574 15.8278C2.28412 16.1008 2.3777 16.363 2.52988 16.5912C2.68205 16.8194 2.88812 17.0066 3.12986 17.1362C3.3716 17.2658 3.64156 17.3339 3.91585 17.3344C4.33085 17.3344 4.74335 17.1793 5.06169 16.8777L11.3117 10.9585C11.5001 10.7803 11.6441 10.5605 11.7324 10.3167C11.8207 10.0729 11.8507 9.81183 11.82 9.55435C11.7901 9.29696 11.7006 9.05011 11.5585 8.8334C11.4164 8.61669 11.2258 8.43611 11.0017 8.30602L8.10002 6.62435L9.59086 3.04685C9.71139 2.79269 9.76564 2.51216 9.74854 2.23139C9.73144 1.95062 9.64356 1.67874 9.49308 1.44108C9.3426 1.20342 9.13442 1.00772 8.88792 0.872198C8.64143 0.736677 8.36465 0.665747 8.08336 0.666016Z",
    fill: "#9747FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggered);
export default __webpack_public_path__ + "static/media/triggered.3df74b4d46cc7676b62e0677b90d1067.svg";
export { ForwardRef as ReactComponent };